var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWishlistCardIcon = function SvgWishlistCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4ECDC4",
    d: "M12.615 1.432h-7.23A2.906 2.906 0 0 0 2.49 4.327v10.567c0 1.35.968 1.92 2.153 1.268l3.66-2.033c.39-.217 1.02-.217 1.402 0l3.66 2.033c1.185.66 2.153.09 2.153-1.268V4.327a2.913 2.913 0 0 0-2.903-2.895Zm-.9 5.34-3 3a.556.556 0 0 1-.397.165.556.556 0 0 1-.398-.165L6.795 8.647a.566.566 0 0 1 0-.795.566.566 0 0 1 .795 0l.728.727 2.602-2.602a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795Z"
  })));
};
export default SvgWishlistCardIcon;